// extracted by mini-css-extract-plugin
export default {"content":"page_content__YYLpS","error":"page_error__Clanq"};